import React from "react";
// Components
import Navbar from "../../components/Navbar";
import ConveniosSVG from "../../assets/navbar/Convenios_on_light_blue.svg";
import { ImPlus } from "react-icons/im";
import * as S from "./styles";
import ListConvenios from "../../components/ListConvenios";
import { useHistory, useLocation } from "react-router-dom";

export default function ConveniosList() {
  const history = useHistory();
  const params = useQuery();

  function useQuery() {
    return new URLSearchParams(useLocation().search);
  }

  return (
    <>
      <Navbar />
      <S.Wrapper>
        <S.Header>
          <S.BoxUser>
            <S.Image src={ConveniosSVG} />
            <div>
              <S.Title>Convênios</S.Title>
              <S.Description>Cadastro geral de convênios</S.Description>
            </div>
          </S.BoxUser>

          <S.AddNew onClick={() => history.push("/cadastro-convenios")}>
            <ImPlus
              style={{
                margin: "0px 0px 30px",
              }}
            />

            <S.Image src={ConveniosSVG} />
          </S.AddNew>
        </S.Header>

        <ListConvenios
          filter={params.get("filter") || ""}
          pageFilter={parseInt(params.get("page") || "0")}
          history={history}
        />
      </S.Wrapper>
    </>
  );
}
